import React, { useEffect, useState } from "react";
import CustomAddActionCard from "../../../../common/components/CustomAddActionCard/CustomAddActionCard";
import CardContentActionTile from "../../../../common/components/CardContentActionTile/CardContentActionTile";
import { Box } from "@mui/system";
import _ from "lodash";
import SkillsDetailsController from "../../../../common/Modals/PersonalDetails/skillsDetailModal/SkillsDetailsController";
import EditSkillModal from "../../../../common/Modals/PersonalDetails/skillsDetailModal/EditSkill/EditSkillModal";
import { useAppSelector } from "../../../../infra/hooks";

interface propsType {
  allSkillsData: any;
  onDeleteSkill: (id: number) => void;
  onEditSkill: (editPayload: any) => void;
  hr_view?: boolean;
  trans?: any;
}
const SkillDetailsPresenter: React.FC<propsType> = ({
  allSkillsData,
  onDeleteSkill,
  onEditSkill,
  hr_view,
  trans,
}) => {
  const empId: number = useAppSelector((state) => state.authSlice.emp_id);

  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [skillId, setSkillId] = useState(0);
  const [skillName, setSkillName] = useState<string>("");

  const handleEditSkill = (skillName: string) => {
    if (skillId > 0 && skillName.length) {
      const payload: any = {
        emp_id: empId,
        id: skillId,
        skill_name: skillName,
        locale: localStorage.getItem("emplang"),
      };
      onEditSkill(payload);
    }
  };
  return (
    <div>
      <CustomAddActionCard
        card_title={trans("Skills")}
        card_subtitle={`${trans("Total")} : ${allSkillsData?.length}`}
        card_height="310px"
        onClick={() => setOpenModal(true)}
        isAddButton={true}
      >
        <Box style={{ marginBottom: "24px" }} />
        {_.map(allSkillsData, (skill: any) => {
          return (
            <div>
              <CardContentActionTile
                tile_value={skill.name}
                onDelete={() => onDeleteSkill(skill.id)}
                onEdit={() => {
                  setOpenEditModal(true);
                  setSkillName(skill.name);
                  setSkillId(skill.id);
                }}
              />
            </div>
          );
        })}
      </CustomAddActionCard>

      {/* Add Employee Skill Modal */}

      {openModal && (
        <SkillsDetailsController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          trans={trans}
        />
      )}

      {/* Skills Detail Edit Modal */}
      {openEditModal && (
        <EditSkillModal
          isModalOpen={openEditModal}
          closeModal={() => setOpenEditModal(false)}
          callBackSetEditSkill={handleEditSkill}
          editedSkillName={skillName}
          trans={trans}
        />
      )}
    </div>
  );
};

export default SkillDetailsPresenter;
